import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import InsurerDTO from '../../../../dto/InsurerDTO';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import CustomSelectInputWithHelper from '../../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadInsuranceCompaniesList } from '../../../ReferenceInformation/actions';

export default function OsgopInsuranceForm(props) {
  const {
    prefix = '', labelPrefix = '', disabled = false, control, selectedProcedure = '', formMeta, index, hideFileInput = false,
  } = props;
  const dto = new InsurerDTO();
  const attributes = dto.getAttributesByName();

  return (
    <>
      <Row className="row-cols-3">
        <FieldDTOWithCol
          formMeta={formMeta}
          control={control}
          component={CustomSelectInputWithHelper}
          dtoObject={attributes.insurer}
          namePrefix={`${prefix}${index}.`}
          portalClassName="executor-selector"
          loadAction={loadInsuranceCompaniesList}
          optionFormatter={item => ({ value: item.name, name: item.name })}
          variant="material"
          disabled={disabled}
          type="text"
          columns={8}
          withLabel
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.insurance_contract_number}
          variant="material"
          namePrefix={`${prefix}${index}.`}
          labelPrefix={labelPrefix}
          disabled={disabled}
          columns={4}
        />
      </Row>
      <Row className={!hideFileInput ? 'row-cols-3' : 'row-cols-2'}>
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          hideTime
          changeFormat="YYYY-MM-DD"
          dtoObject={attributes.insurance_contract_effective_date}
          variant="material"
          namePrefix={`${prefix}${index}.`}
          labelPrefix={labelPrefix}
          disabled={disabled}
          withLabel
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          hideTime
          changeFormat="YYYY-MM-DD"
          dtoObject={attributes.insurance_contract_expiration_date}
          variant="material"
          namePrefix={`${prefix}${index}.`}
          labelPrefix={labelPrefix}
          disabled={disabled}
          withLabel
        />
        {
          !hideFileInput ? (
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.osgop_files}
              namePrefix={`${prefix}${index}.`}
              variant="material"
              multiple
            />
          ) : null
        }
      </Row>
    </>
  );
}
